<section class="playground">
  <h2 class="playground__heading">Area picture uploader</h2>
  <p class="playground__hint">
    <code>common-area-picture-uploader</code> — estado <code>empty</code>/<code>filled</code> derivado del <code>imageUrl</code>, 2 tamaños.<br />
    <strong>Figma DS:</strong> <code>area_picture_uploader_item</code> ·
    <a href="https://www.figma.com/design/nZEfdJ8pN0ILY9cAkO3DSG/Munily-UI-Kit-%7C-Design-system?node-id=8881-18176" target="_blank" rel="noopener">
      UI Kit → node 8881-18176
    </a>
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>imageUrl (estado filled si tiene valor)</span>
        <input type="text" [(ngModel)]="imageUrl" placeholder="https://..." />
      </label>

      <label class="playground__field">
        <span>size</span>
        <select [(ngModel)]="size">
          <option *ngFor="let s of sizes" [value]="s">{{ s }}</option>
        </select>
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="disabled" />
        <span>disabled</span>
      </label>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Preview</p>
      <div class="playground__preview-box">
        <common-area-picture-uploader
          [imageUrl]="imageUrl || undefined"
          [size]="size"
          [disabled]="disabled"
          (upload)="onUpload()"
          (remove)="onRemove()"
        ></common-area-picture-uploader>
      </div>

      <p *ngIf="lastEvent" class="playground__meta">{{ lastEvent }}</p>

      <p class="playground__preview-title playground__preview-title--spaced">Ambos tamaños (empty)</p>
      <div class="playground__preview-box playground__preview-box--row">
        <common-area-picture-uploader *ngFor="let s of sizes" [size]="s"></common-area-picture-uploader>
      </div>
    </div>
  </div>
</section>
